import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import { TableWrapper, Badge, Filters, SliderOverlay, ConfirmModal } from "../../component/common/"
import { PhysicalRestrictionModal } from "../../component/master"
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { getPhysicalRestrictionListDetails, createPhysicalRestriction, editPhysicalRestriction, deletePhysicalRestriction } from "../../redux/actions/master"
import { getSNo } from "../../services/helperFunctions"

import { LoaderWrapper } from "../../HOC"


class PhysicalRestrictionClass extends Component {
	state = {
		headerDetails: [
			{
				label: 'S.No',
			},
			{
				label: 'Title',
			},
			{
				label: 'Status',
			},
			{
				label: 'Action'
			},

		],
		filter: [


			{
				label: 'Active',
				value: 1
			},
			{
				label: 'Deactive',
				value: 2
			}

		],
		physicalRestrictionLists: {},
		selectedFilter: 'Active',
		physicalRestrictionDetails: {
			restriction_name: '',

		},
		isError: false,
		isOpen: false,
		isEdit: false,
		ConfirmModalOpenStatus: false,
		id: ''
	}


	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentDidMount() {
		this.setState({
			physicalRestrictionLists: this.props.physicalRestrictionLists
		})
	}


	requestStatus = (status) => {

		if (status === 1) {
			return <Badge
				type={1}
				label={"Active"}
			/>
		} else if (status === 2) {
			return <Badge
				type={2}
				label={"Pending"}
			/>
		}

	}

	handleFilter = (query, value, name) => {

		if (name == "filter") {
			this.setState({
				selectedFilter: query
			})

			query = {
				pageNo: 1,
				filter: query
			}
		}

		this.props.getPhysicalRestrictionListDetails(query)



	}




	handleAdd = () => {
		let temp = {
			restriction_name: '',
		}


		this.setState({
			isOpen: true,
			physicalRestrictionDetails: temp
		})
	}



	handleEdit = (index) => {

		let { physicalRestrictionLists: { list } } = this.props

		let physicalRestrictionDetails = list[index]

		this.setState({
			isEdit: true,
			physicalRestrictionDetails,
			currentIndex: index

		})

		this.toggle("isOpen")

	}

	toggle = item => {
		this.setState(prevState => ({
			[item]: !prevState[item]
		}));
	}

	handleModal = () => {

		let temp = {
			restriction_name: '',
		}

		this.setState({
			isError: false,
			isOpen: false,
			isEdit: false,
			physicalRestrictionDetails: temp

		})
	}

	handleDeleteToggle = (id) => {

		this.setState({
			id
		})

		this.toggleDelete("ConfirmModalOpenStatus")

	}


	handleDelete = () => {
		let { id } = this.state

		this.props.deletePhysicalRestriction(id).then(() => {

			this.props.getPhysicalRestrictionListDetails()

			this.toggleDelete("ConfirmModalOpenStatus")

		})

	}

	toggleDelete = (name) => {
		this.setState({
			[name]: !this.state[name]
		})
	}




	render() {

		let { headerDetails, filter, selectedFilter, physicalRestrictionDetails, isError, isOpen, isEdit, ConfirmModalOpenStatus } = this.state
		let { physicalRestrictionLists } = this.props
		let IsEmpty = physicalRestrictionLists.list.length > 0


		return (
			<div>
				<div className="sair-pg-header">
					<h4 className="sair-pg-title align-self-center">
						<span className="pg-title-icon">
							<span className="feather-icon">
								<svg
									xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
									fill="none" stroke="currentColor" className="feather feather-align-left">
									<line x1="17" y1="10" x2="3" y2="10"></line>
									<line x1="21" y1="6" x2="3" y2="6"></line>
									<line x1="21" y1="14" x2="3" y2="14"></line>
									<line x1="17" y1="18" x2="3" y2="18"></line>
								</svg>
							</span>
						</span>Physical Restriction
					</h4>
					<div className="col-auto ">
						<button className="btn btn-primary btn-sm"
							onClick={() => this.handleAdd()}
						>Add Physical Restriction</button>
					</div>
				</div>
				<section className="sair-sec-wrapper">
					<div className="row">
						<div className="col-sm">
							<div className="row no-gutters">
								<h5 className="sair-sec-title align-self-center">Physical Restriction List</h5>
								<div className="ml-auto d-flex align-items-center">
									{/* <UncontrolledDropdown setActiveFromChild className="filter-dropdown">
										<DropdownToggle tag="a" className="custom-caret dropdown-toggle-link">
											Filter by: {selectedFilter}
										</DropdownToggle>
										<DropdownMenu>
											{filter.map(({ label, value }, index) => {
												return (
													<DropdownItem
														onClick={e => this.handleFilter(label, value, "filter")}
														key={index}
													>
														{label}
													</DropdownItem>

												)
											})}
										</DropdownMenu>
									</UncontrolledDropdown> */}

									<div className="search-box position-relative  ml-3">

										{/* <Filters
											queryHandler={(query) => this.handleFilter(query)}
											isDropDownFilter={false}
										/> */}
									</div>
								</div>
							</div>
							<div className="table-wrap mt-3">
								<TableWrapper
									headerDetails={headerDetails}
									isEmpty={IsEmpty}
									pageMeta={physicalRestrictionLists.pageMeta}
									queryHandler={(query) => this.handleFilter(query)}


								>
									{physicalRestrictionLists.list.map((item, index) => {
										let { id, restriction_name, status } = item

										return (
											<tr
												key={index}  >
												<td>{getSNo(physicalRestrictionLists.pageMeta, index)}</td>
												<td>{restriction_name}</td>
												<td>{this.requestStatus(status)}</td>
												<td>
													<a className="mr-25"
														onClick={e => this.handleEdit(index)}
													>
														<i className="icon-pencil  text-primary cursor-pointer"
														></i>
													</a>
													<a ><i
														className="icon-trash txt-danger text-primary cursor-pointer"
														onClick={e => this.handleDeleteToggle(id)}
													></i>
													</a>
												</td>

											</tr>

										)

									})}


								</TableWrapper>
							</div>
						</div>
					</div>
				</section>



				<SliderOverlay isOpen={isOpen} toggle={this.handleModal} size='30%'>
					<div className="side-slider h-100 position-relative">
						<div className="h-100 flex-with-center">
							<PhysicalRestrictionModal
								isError={isError}
								toggle={this.handleModal}
								isEdit={isEdit}
								modalDetails={physicalRestrictionDetails}
							/>
						</div>

					</div>
				</SliderOverlay>

				<ConfirmModal
					keyName="ConfirmModalOpenStatus"
					toggle={this.toggle}
					isOpen={ConfirmModalOpenStatus}
					handleSubmit={() => this.handleDelete()}
					submitText='Delete'
				>
					<h5>
						Are you sure want to delete Physical Restriction?
					</h5>
				</ConfirmModal>

			</div>
		)
	}
}

const mapStateToProps = state => {

	return {
		physicalRestrictionLists: state.master.physicalRestrictionLists
	}


};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		getPhysicalRestrictionListDetails,
		createPhysicalRestriction,
		editPhysicalRestriction,
		deletePhysicalRestriction
	}, dispatch)
};


let actions = ['getPhysicalRestrictionListDetails']

let component = LoaderWrapper(PhysicalRestrictionClass)({ actions })

export const PhysicalRestriction = connect(mapStateToProps, mapDispatchToProps)(component)

